import React from "react";
import AppStoreImage from "../../assets/images/app_stor_img.png";
import PlayStoreImage from "../../assets/images/play-store-img.png";

const badges = [
  { src: AppStoreImage, alt: "App Store — coming soon", delay: "0.2s" },
  { src: PlayStoreImage, alt: "Google Play — coming soon", delay: "0.5s" },
];

const StoreLinks = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        width: "100%",
        height: "100%",
      }}
    >
      {badges.map((b) => (
        <div
          key={b.alt}
          aria-disabled="true"
          title="Coming soon"
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            cursor: "not-allowed",
            opacity: 0,
            animation: `fadeSlideUp 0.8s ease forwards ${b.delay}`,
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "180px",
              borderRadius: 20,
              overflow: "hidden",
            }}
          >
            <img
              src={b.src}
              alt={b.alt}
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                borderRadius: 20,
                filter: "grayscale(1) brightness(0.55) contrast(0.9)",
                opacity: 0.75,
              }}
            />

            <div
              aria-hidden="true"
              style={{
                position: "absolute",
                inset: 0,
                borderRadius: 20,
                background: "rgba(0, 0, 0, 0.35)",
                pointerEvents: "none",
              }}
            />

            <div
              aria-hidden="true"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(-12deg)",
                padding: "5px 16px",
                borderRadius: 6,
                border: "1px solid rgba(255, 255, 255, 0.5)",
                background: "rgba(0, 0, 0, 0.55)",
                color: "#fff",
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: "0.16em",
                textTransform: "uppercase",
                whiteSpace: "nowrap",
                pointerEvents: "none",
                textShadow: "0 1px 3px rgba(0,0,0,0.6)",
              }}
            >
              Coming soon
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StoreLinks;